<div class="editor-container" [formGroup]="form_group()">
  <editor
    formControlName="content"
    [apiKey]="tiny_mce_api_key()"
    cloudChannel="6"
    id="acta_html"
    [init]="tiny_mce_init()"
    initialValue=""
    [inline]="false"
    tagName="div"
    (onInit)="onEditorInit($event)"
  ></editor>
</div>
